import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { Theme as v } from "./Theme/Theme.js";
import { Button as H } from "./Button/Button.js";
import { PaginationButton as E } from "./PaginationButton/PaginationButton.js";
import { Icon as w, IconBase as L } from "./Icon/Icon.js";
import { ButtonsContainer as M } from "./ButtonsContainer/ButtonsContainer.js";
import { SectionContainer as O } from "./SectionContainer/SectionContainer.js";
import { Logo as q } from "./Logo/Logo.js";
import { ProductTypeColor as G } from "./ProductTypeColor/ProductTypeColor.js";
import { SectionDivider as j } from "./SectionDivider/SectionDivider.js";
import { SectionTitle as K, SectionTitleBody as Q, SectionTitleHeading as X } from "./SectionTitle/SectionTitle.js";
import { TextStyle as Z } from "./TextStyle/TextStyle.js";
import { b as $, a as oo, D as eo, g as ro } from "./DescriptionText-DQngKYt5.js";
import { DescriptionTextColumn as io, DescriptionTextColumnContent as no, DescriptionTextColumnContentLeft as so, DescriptionTextColumnContentRight as ao, DescriptionTextColumnIconHighlights as lo, DescriptionTextColumnLeadIn as co, DescriptionTextColumnTitle as po } from "./DescriptionTextColumn/DescriptionTextColumn.js";
import { DropDown as mo } from "./DropDown/DropDown.js";
import { Modal as xo, ModalBody as ho, ModalBodyContent as Io, ModalBodyTitle as go, ModalFooter as Co, modalSetAppElement as Po } from "./Modal/Modal.js";
import { Slider as Fo, SliderSlide as So } from "./Slider/Slider.js";
import { SliderControls as To, defaultLabels as bo } from "./Slider/SliderControls.js";
import { MosaicLayout as vo, cardImageRatioForMosaicIndex as ko } from "./MosaicLayout/MosaicLayout.js";
import { PictureCard as Ao, PictureCardImage as Eo, PictureCardTitle as Ro } from "./PictureCard/PictureCard.js";
import { BaseCard as Lo, BaseCardBody as Wo, BaseCardFooter as Mo, BaseCardImage as Uo, BaseCardImageFooter as Oo, BaseCardSanityImage as zo, BaseCardTitle as qo } from "./BaseCard/BaseCard.js";
import { OpeningText as Go, OpeningTextBody as No, OpeningTextHeading as jo, OpeningTextSubHeading as Jo } from "./OpeningText/OpeningText.js";
import { Pagination as Qo } from "./Pagination/Pagination.js";
import { ImageRatio as Yo, computeAspectRatioStyle as Zo } from "./ImageRatio/ImageRatio.js";
import { SanityImageRatio as $o } from "./ImageRatio/SanityImageRatio.js";
import { R as ee, u as re } from "./ResponsiveSanityImage-BfPbiFwC.js";
import { SanityClientConfigContext as ie, useSanityClient as ne } from "./useSanityClient.js";
import { HeroBanner as ae, HeroBannerAction as le, HeroBannerCenterPanel as ce, HeroBannerContent as pe, HeroBannerLeftPanel as de, HeroBannerRightPanel as ue, HeroBannerTitle as me } from "./HeroBanner/HeroBanner.js";
import { BarCheckbox as xe } from "./BarCheckbox/BarCheckbox.js";
import { Spinner as Ie } from "./Spinner/Spinner.js";
import { ReadMore as Ce } from "./ReadMore/ReadMore.js";
import { Chip as ye } from "./Chip/Chip.js";
import { DiscountChip as Se } from "./DiscountChip/DiscountChip.js";
import { TabsSlider as Te } from "./TabsSlider/TabsSlider.js";
import { ElevatedSectionContainer as De } from "./ElevatedSectionContainer/ElevatedSectionContainer.js";
import { PricesFromWithChip as ke } from "./PricesFromWithChip/PricesFromWithChip.js";
import { PriceItem as Ae } from "./Prices/PriceItem/PriceItem.js";
import { PricesBlock as Re } from "./Prices/PricesBlock/PricesBlock.js";
import { PricesList as Le } from "./Prices/PricesList/PricesList.js";
import { PriceBox as Me, PriceBoxBottomLabel as Ue, PriceBoxTopLabel as Oe, PriceValue as ze } from "./Prices/PriceBox/PriceBox.js";
import { Toggle as Ve } from "./Toggle/Toggle.js";
import { Tooltip as Ne } from "./Tooltip/Tooltip.js";
import { T as Je, a as Ke, b as Qe, u as Xe } from "./Tabs-iRMksboy.js";
import { Tab as Ze } from "./Tabs/Tab.js";
import { UnstyledBlockContent as $e } from "./UnstyledBlockContent/UnstyledBlockContent.js";
import { BlockContentComponentsProvider as er, BlockContentPlaceholderResolverContext as rr } from "./UnstyledBlockContent/BlockContentComponentsProvider.js";
import { isBlockContentValuePresent as ir } from "./UnstyledBlockContent/helpers.js";
import { InlineImage as sr } from "./UnstyledBlockContent/InlineImage.js";
import { SuitesComparison as lr } from "./SuitesComparison/SuitesComparison.js";
import { ShipDeckPlan as pr } from "./ShipDeckPlan/ShipDeckPlan.js";
import { ShipDirectionIcon as ur } from "./ShipDeckPlan/ShipDirectionIcon/ShipDirectionIcon.js";
import { ShipDeckPlansSlider as fr } from "./ShipDeckPlansSlider/ShipDeckPlansSlider.js";
import { ShipDeckPlanSlide as hr } from "./ShipDeckPlansSlider/ShipDeckPlanSlide.js";
import { PromoBadges as gr } from "./PromoBadges/PromoBadges.js";
import { c as Pr, s as yr, a as Fr, t as Sr } from "./strings-CHELOtPc.js";
import { FareInfographicsMosaic as Tr } from "./FareInfographicsMosaic/FareInfographicsMosaic.js";
import { Accordion as Dr } from "./Accordion/Accordion.js";
import { AccordionItem as kr } from "./Accordion/AccordionItem.js";
import { Drawer as Ar } from "./Drawer/Drawer.js";
import { DrawerBody as Rr, defaultDrawerBodyContainerStyle as wr } from "./Drawer/DrawerBody.js";
import { c as Wr, a as Mr } from "./background-DsFsjTc7.js";
import { InlineFormContainer as Or } from "./Form/InlineFormContainer/InlineFormContainer.js";
import { InputForm as qr } from "./Form/InputForm/InputForm.js";
import { FloatLabel as Gr } from "./Form/Inputs/FloatLabel/FloatLabel.js";
import { InputCheckbox as jr } from "./Form/Inputs/InputCheckbox/InputCheckbox.js";
import { InputRadio as Kr } from "./Form/Inputs/InputRadio/InputRadio.js";
import { InputText as Xr } from "./Form/Inputs/InputText/InputText.js";
import { BasicInputWithError as Zr, InputWithError as _r } from "./Form/Inputs/InputWithError/InputWithError.js";
import { PhoneInput as ot, isPossiblePhoneNumber as et } from "./Form/Inputs/PhoneInput/PhoneInput.js";
import { Select as tt } from "./Form/Inputs/Select/Select.js";
import { TextArea as nt } from "./Form/Inputs/TextArea/TextArea.js";
import { FormGenericErrorMessage as at } from "./Form/FormGenericErrorMessage/FormGenericErrorMessage.js";
import { FormRow as ct } from "./Form/FormRow/FormRow.js";
import { b as dt, i as ut, a as mt } from "./utils-Dbbe_U2M.js";
import { SanityImage as xt } from "./SanityImage/SanityImage.js";
import { PenaltiesInfographic as It } from "./PenaltiesInfographic/PenaltiesInfographic.js";
import { PenaltiesInfographicIconStep as Ct, PenaltiesInfographicStep as Pt } from "./PenaltiesInfographic/PenaltiesInfographicStep.js";
import { SuiteCardBase as Ft, SuiteCardImageFooter as St, SuiteCardTitle as Bt } from "./SuiteCard/SuiteCardBase.js";
import { SuiteCard as bt } from "./SuiteCard/SuiteCard.js";
import { SuiteCardSkeleton as vt } from "./SuiteCard/SuiteCardSkeleton.js";
import { SuiteCardChooseButton as Ht } from "./SuiteCard/SuiteCardChooseButton.js";
import { SuiteCardImageFooterWithTooltip as Et } from "./SuiteCard/SuiteCardImageFooterWithTooltip.js";
import { HorizontalSuiteCard as wt } from "./SuiteCard/HorizontalSuiteCard.js";
import { HorizontalSuiteCardBase as Wt } from "./SuiteCard/HorizontalSuiteCardBase.js";
import { HorizontalSuiteCardSkeleton as Ut } from "./SuiteCard/HorizontalSuiteCardSkeleton.js";
import { match as d, P as u } from "ts-pattern";
import { i as l } from "./checks-C6AyTTQ0.js";
import { FareInfographic as zt } from "./FareInfographic/FareInfographic.js";
import { FareInfographicSkeleton as Vt } from "./FareInfographic/FareInfographicSkeleton.js";
import { FareCardBase as Nt, FareCardBaseContent as jt } from "./FareCard/FareCardBase.js";
import { FareCardRefundability as Kt } from "./FareCard/FareCardRefundability.js";
import { FareCardHeader as Xt } from "./FareCard/FareCardHeader/FareCardHeader.js";
import { FareCardFooter as Zt } from "./FareCard/FareCardFooter/FareCardFooter.js";
import { StaticFareCard as $t } from "./FareCard/StaticFareCard/StaticFareCard.js";
import { FareCardSkeleton as ei } from "./FareCard/FareCardSkeleton/FareCardSkeleton.js";
const f = o => e => o.includes(e),
  c = (o, e) => e.find(r => r.codes.includes(o)),
  m = (o, e) => (o || []).some(r => r && e.includes(r)),
  x = o => _ref => {
    let {
      onlyWhenActiveCodes: e,
      code: r
    } = _ref;
    return m(e, o) ? r : void 0;
  },
  h = o => _ref2 => {
    let {
      exceptWhenActiveCodes: e,
      code: r
    } = _ref2;
    return m(e, o) ? void 0 : r;
  },
  I = (o, e) => d(o).with(void 0, () => {}).with(u.string, r => r).with({
    type: "only"
  }, x(e)).with({
    type: "except"
  }, h(e)).exhaustive();
function p(o, e) {
  const r = o.overrideIcon;
  return d(r).with(void 0, () => e[0].icon).with({
    strategy: "all-active"
  }, t => e.length == o.inclusions.length ? t.icon : e[0].icon).with({
    strategy: "all-active-inclusions"
  }, t => {
    const i = e.flatMap(n => n.codes);
    return t.inclusions.every(n => i.includes(n)) ? t.icon : e[0].icon;
  }).with(u.string, t => t).exhaustive();
}
const g = (o, e, r, t) => {
    const i = o.inclusions.filter(f(e)),
      s = I(o.fallbackInclusion, e);
    if (i.length == 0 && l(s)) {
      const a = c(s, r);
      return a ? {
        id: o.id,
        groupId: t,
        type: "disabled",
        icon: p(o, [a]),
        inclusions: [a]
      } : void 0;
    }
    const n = i.map(a => c(a, r)).filter(l);
    if (n[0]) return {
      id: o.id,
      groupId: t,
      type: "active",
      inclusions: n,
      icon: p(o, n)
    };
  },
  B = (o, e, r, t) => o.groups.map(i => {
    const s = i.steps.map(n => g(n, e, r, i.id)).filter(l);
    return {
      id: i.id,
      icon: i.icon,
      title: (t == null ? void 0 : t[i.id]) || i.id,
      steps: s
    };
  }).filter(l),
  C = {
    groups: [{
      id: "pre-cruise",
      icon: "pre-cruise",
      steps: [{
        id: "pre-door-2-door",
        inclusions: ["PreDoor2Door"],
        fallbackInclusion: "PreDoor2Door"
      }, {
        id: "pre-air",
        inclusions: ["InternationalFlights", "BusinessFlights", "EconomyFlights", "EconomyFlightsWithUpgrade", "BusinessUpgraded"],
        fallbackInclusion: "InternationalFlights"
      }, {
        id: "pre-hotel",
        inclusions: ["PreInCountryFlight", "PreHotel"],
        overrideIcon: {
          strategy: "all-active-inclusions",
          inclusions: ["PreInCountryFlight", "PreHotel"],
          icon: "hotel-charter"
        }
      }, {
        id: "pre-antarctica-bridge",
        inclusions: ["PreAntarcticaBridgeFlight"]
      }]
    }, {
      id: "cruise",
      icon: "ship-lateral",
      steps: [{
        id: "cruise",
        inclusions: ["FoodAndBeverage", "Butler", "SpecialEquipments", "ExpeditionCruiseExtras"],
        overrideIcon: "ship-lateral"
      }]
    }, {
      id: "shorex",
      icon: "shore-excursions",
      steps: [{
        id: "shorex",
        inclusions: ["FreeShorex", "FreeShorexExpedition"]
      }]
    }, {
      id: "post-cruise",
      icon: "post-cruise",
      steps: [{
        id: "post-antarctica-bridge",
        inclusions: ["PostAntarcticaBridgeFlight"]
      }, {
        id: "post-hotel",
        inclusions: ["PostHotel", "PostInCountryFlight"],
        overrideIcon: {
          strategy: "all-active-inclusions",
          inclusions: ["PostHotel", "PostInCountryFlight"],
          icon: "hotel-charter"
        }
      }, {
        id: "post-air",
        inclusions: ["InternationalFlights", "BusinessFlights", "EconomyFlights", "EconomyFlightsWithUpgrade", "BusinessUpgraded"],
        fallbackInclusion: "InternationalFlights"
      }, {
        id: "post-door-2-door",
        inclusions: ["PostDoor2Door"],
        fallbackInclusion: "PostDoor2Door"
      }]
    }]
  },
  P = {
    groups: [{
      id: "pre-cruise",
      icon: "pre-cruise",
      steps: [{
        id: "pre-door-2-door",
        inclusions: ["PreDoor2Door"],
        fallbackInclusion: "PreDoor2Door"
      }, {
        id: "pre-air",
        inclusions: ["InternationalFlights", "BusinessFlights", "EconomyFlights", "EconomyFlightsWithUpgrade", "BusinessUpgraded"],
        fallbackInclusion: "InternationalFlights"
      }, {
        id: "transfer-airport-to-pier",
        inclusions: ["TransferInternationalAirportToPier"],
        fallbackInclusion: {
          type: "except",
          code: "TransferInternationalAirportToPier",
          exceptWhenActiveCodes: ["PreHotel", "PreInCountryFlight"]
        }
      }, {
        id: "transfer-airport-to-hotel",
        inclusions: ["TransferInternationalAirportToHotel"],
        fallbackInclusion: {
          type: "only",
          code: "TransferInternationalAirportToHotel",
          onlyWhenActiveCodes: ["PreHotel"]
        }
      }, {
        id: "pre-hotel",
        inclusions: ["PreHotel", "PreInCountryFlight"],
        overrideIcon: {
          strategy: "all-active-inclusions",
          inclusions: ["PreHotel", "PreInCountryFlight"],
          icon: "hotel-charter"
        }
      }]
    }, {
      id: "cruise",
      icon: "ship-lateral",
      steps: [{
        id: "cruise",
        inclusions: ["FoodAndBeverage", "Butler", "SpecialEquipments", "ExpeditionCruiseExtras"],
        overrideIcon: "ship-lateral"
      }]
    }, {
      id: "shorex",
      icon: "shore-excursions",
      steps: [{
        id: "shorex",
        inclusions: ["FreeShorex", "FreeShorexExpedition"]
      }]
    }, {
      id: "post-cruise",
      icon: "post-cruise",
      steps: [{
        id: "post-hotel",
        inclusions: ["PostInCountryFlight", "PostHotel", "PostDayStay"],
        overrideIcon: {
          strategy: "all-active-inclusions",
          inclusions: ["PostInCountryFlight", "PostHotel"],
          icon: "hotel-charter"
        }
      }, {
        id: "transfer-hotel-to-airport",
        inclusions: ["TransferHotelToInternationalAirport"],
        fallbackInclusion: {
          type: "only",
          code: "TransferHotelToInternationalAirport",
          onlyWhenActiveCodes: ["PostHotel", "PostDayStay"]
        }
      }, {
        id: "transfer-pier-to-airport",
        inclusions: ["TransferPierToInternationalAirport"],
        fallbackInclusion: {
          type: "except",
          code: "TransferPierToInternationalAirport",
          exceptWhenActiveCodes: ["PostHotel", "PostDayStay", "PostInCountryFlight"]
        }
      }, {
        id: "post-air",
        inclusions: ["InternationalFlights", "BusinessFlights", "EconomyFlights", "EconomyFlightsWithUpgrade", "BusinessUpgraded"],
        fallbackInclusion: "InternationalFlights"
      }, {
        id: "post-door-2-door",
        inclusions: ["PostDoor2Door"],
        fallbackInclusion: "PostDoor2Door"
      }]
    }]
  },
  T = o => {
    switch (o) {
      case "antarcticaBridge":
        return C;
      default:
        return P;
    }
  };
export { Dr as Accordion, kr as AccordionItem, xe as BarCheckbox, Lo as BaseCard, Wo as BaseCardBody, Mo as BaseCardFooter, Uo as BaseCardImage, Oo as BaseCardImageFooter, zo as BaseCardSanityImage, qo as BaseCardTitle, Zr as BasicInputWithError, er as BlockContentComponentsProvider, rr as BlockContentPlaceholderResolverContext, H as Button, M as ButtonsContainer, ye as Chip, $ as DescriptionText, io as DescriptionTextColumn, no as DescriptionTextColumnContent, so as DescriptionTextColumnContentLeft, ao as DescriptionTextColumnContentRight, lo as DescriptionTextColumnIconHighlights, co as DescriptionTextColumnLeadIn, po as DescriptionTextColumnTitle, oo as DescriptionTextContent, eo as DescriptionTextLeadIn, Se as DiscountChip, Ar as Drawer, Rr as DrawerBody, mo as DropDown, De as ElevatedSectionContainer, Nt as FareCardBase, jt as FareCardBaseContent, Zt as FareCardFooter, Xt as FareCardHeader, Kt as FareCardRefundability, ei as FareCardSkeleton, zt as FareInfographic, Vt as FareInfographicSkeleton, Tr as FareInfographicsMosaic, Gr as FloatLabel, at as FormGenericErrorMessage, ct as FormRow, ae as HeroBanner, le as HeroBannerAction, ce as HeroBannerCenterPanel, pe as HeroBannerContent, de as HeroBannerLeftPanel, ue as HeroBannerRightPanel, me as HeroBannerTitle, wt as HorizontalSuiteCard, Wt as HorizontalSuiteCardBase, Ut as HorizontalSuiteCardSkeleton, w as Icon, L as IconBase, Yo as ImageRatio, Or as InlineFormContainer, sr as InlineImage, jr as InputCheckbox, qr as InputForm, Kr as InputRadio, Xr as InputText, _r as InputWithError, q as Logo, xo as Modal, ho as ModalBody, Io as ModalBodyContent, go as ModalBodyTitle, Co as ModalFooter, vo as MosaicLayout, Go as OpeningText, No as OpeningTextBody, jo as OpeningTextHeading, Jo as OpeningTextSubHeading, Qo as Pagination, E as PaginationButton, It as PenaltiesInfographic, Ct as PenaltiesInfographicIconStep, Pt as PenaltiesInfographicStep, ot as PhoneInput, Ao as PictureCard, Eo as PictureCardImage, Ro as PictureCardTitle, Me as PriceBox, Ue as PriceBoxBottomLabel, Oe as PriceBoxTopLabel, Ae as PriceItem, ze as PriceValue, Re as PricesBlock, ke as PricesFromWithChip, Le as PricesList, G as ProductTypeColor, gr as PromoBadges, Ce as ReadMore, ee as ResponsiveSanityImage, ie as SanityClientConfigContext, xt as SanityImage, $o as SanityImageRatio, O as SectionContainer, j as SectionDivider, K as SectionTitle, Q as SectionTitleBody, X as SectionTitleHeading, tt as Select, pr as ShipDeckPlan, hr as ShipDeckPlanSlide, fr as ShipDeckPlansSlider, ur as ShipDirectionIcon, Fo as Slider, To as SliderControls, So as SliderSlide, Ie as Spinner, $t as StaticFareCard, bt as SuiteCard, Ft as SuiteCardBase, Ht as SuiteCardChooseButton, St as SuiteCardImageFooter, Et as SuiteCardImageFooterWithTooltip, vt as SuiteCardSkeleton, Bt as SuiteCardTitle, lr as SuitesComparison, Ze as Tab, Je as TabList, Ke as TabPanel, Qe as Tabs, Te as TabsSlider, nt as TextArea, Z as TextStyle, v as Theme, Ve as Toggle, Ne as Tooltip, $e as UnstyledBlockContent, dt as buildSanityImageSrc, Pr as capitalize, ko as cardImageRatioForMosaicIndex, Wr as classForBackground, Zo as computeAspectRatioStyle, B as computeInfographic, g as computeStep, Mr as cssVariableForColor, wr as defaultDrawerBodyContainerStyle, bo as defaultLabels, ro as getHeadingElement, c as inclusionContentForCode, T as infographicConifg, f as isActiveInclusion, ir as isBlockContentValuePresent, et as isPossiblePhoneNumber, ut as isSanityImagePresent, I as maybeFallbackInclusionCode, Po as modalSetAppElement, mt as sanityImageUrl, yr as snakeCase, Fr as stringPresent, Sr as titleCase, re as useDebouncedResizeObserver, ne as useSanityClient, Xe as useSticky };